/* eslint-disable */
function init() {
    const $cartsummary = $('#cart-summary');
    const $paymentmodes = $('.payment-modes');
    $(window).on('scroll', function () {
        const scrollTop = $(this).scrollTop();
        const docHeight = $(document).height();
        const windowHeight = $(this).height();
        if (scrollTop + windowHeight >= docHeight-10) {
            $cartsummary.addClass('bt-d-none');
            $paymentmodes.addClass('bt-d-none');
        } else {
            $cartsummary.removeClass('bt-d-none');
            $paymentmodes.removeClass('bt-d-none');
        }
    });
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/pages/cart/cartsummary.js